@if (!isLoading) {
    <div class="p-3">
        <span class="general-info">
            <div class="grid">
                <div class="col-2">Customer</div>
                <div class="col-10">{{ alertData.alarmConfig.site.customer.name }}</div>
            </div>

            <div class="grid">
                <div class="col-2">Site</div>
                <div class="col-10">{{ alertData.alarmConfig.site.name }}</div>
            </div>

            <div class="grid">
                <div class="col-2">Alert Name</div>
                <div class="col-10">{{ alertData.alarmConfig.name }}</div>
            </div>

            <div class="grid">
                <div class="col-2">Alert Type</div>
                <div class="col-10">{{ alertData.alarmConfig.type }}</div>
            </div>

            <div class="grid">
                <div class="col-2">Alert Lifecycle</div>
                <div class="col-10">{{ alertData.alarmBackendStatus }}</div>
            </div>

            <div class="grid">
                <div class="col-2">Alert Description</div>
                <div class="col-10 ql-editor-wrapper">
                    @if (isGeneratedFromTemplate) {
                        <span class="ql-editor">
                            <div [innerHTML]="descriptionToSave | safeHtml"></div>
                        </span>
                    } @else {
                        @if (enableTextEditor) {
                            <cc-text-editor [(htmlStr)]="descriptionToSave"></cc-text-editor>
                            <div class="btn-group">
                                @if (isSavingDescription) {
                                    <mat-spinner [color]="'warn'" [diameter]="40"></mat-spinner>
                                }
                                <button
                                    pButton
                                    class="p-button-raised button-turquoise-bg"
                                    [disabled]="descriptionToSave?.length === 0 || isSavingDescription"
                                    (click)="saveAlertDescription()">
                                    Save
                                </button>
                                <button
                                    pButton
                                    class="p-button-raised button-turquoise-bg"
                                    [disabled]="isSavingDescription"
                                    (click)="cancelEditAlertDescription()">
                                    Cancel
                                </button>
                            </div>
                        } @else {
                            <span class="ql-editor">
                                <div [innerHTML]="descriptionToSave | safeHtml"></div>
                            </span>
                            <div class="btn-group">
                                <button
                                    pButton
                                    class="p-button-raised button-turquoise-bg"
                                    (click)="editAlertDescription()">
                                    Edit
                                </button>
                            </div>
                        }
                    }
                </div>
            </div>
        </span>

        <hr>

        <cc-query-builder [isReadOnly]="true" [comparisonType]="alertData.alarmConfig.comparisonType" [query]="alertData.alarmFilterMatcherResult"></cc-query-builder>

        <button
            pButton
            class="p-button-raised button-turquoise-bg mb-3"
            (click)="showTelemetryDialog()"
        >
            View Analysis
        </button>

        <span class="time-alert">
            <div class="grid">
                <div class="col-3">SharePoint Ticket Number</div>
                <div class="col-9">{{ sharepointNumber }}</div>
            </div>
            <div class="grid">
                <div class="col-3">Time Alert Started</div>
                <div class="col-5">
                    {{ alertData.startDate | dateInSiteTimeZone: siteTimezone }}
                </div>
                <div class="col-4">
                    <div class="cbms-redBg">Active Rule or Condition</div>
                </div>
            </div>

            <div class="grid">
                <div class="col-3">Time Alert Ended</div>
                <div class="col-5">
                    {{ alertData.endDate === null ? 'N/A' : (alertData.endDate | dateInSiteTimeZone: siteTimezone) }}
                </div>
                <div class="col-4">
                    <div class="cbms-yellowBg">Missing Historical Data</div>
                </div>
            </div>
        </span>
    </div>
}

<div class="footer">
    <button
        pButton
        class="p-button-raised button-turquoise-bg"
        (click)="close()">
        Close
    </button>
</div>
